import { ProfileStateI, getProfileTypes, profileTypes } from "./profileTypes";

export const initialState: ProfileStateI = {
  userInformationLoading   : false,
  userInformationError     : "",
  updateInformationLoading : false,
  updateInformationError   : "",
  updateAvatarLoading      : false,
  updateAvatarError        : "",
};

const ACTION_REDUCER = {
  [profileTypes.GET_USER_INFORMATION]: (state: ProfileStateI) => ({
    ...state,
    userInformationLoading : true,
    userInformationError   : "",
  }),
  [profileTypes.GET_USER_INFORMATION_SUCCESS]: (state: ProfileStateI) => ({
    ...state,
    userInformationLoading : false,
    userInformationError   : "",
  }),
  [profileTypes.GET_USER_INFORMATION_FAILURE]: (state: ProfileStateI, { payload }: getProfileTypes) => ({
    ...state,
    userInformationLoading : false,
    userInformationError   : payload,
  }),
  [profileTypes.UPDATE_INFORMATION]: (state: ProfileStateI) => ({
    ...state,
    updateInformationLoading : true,
    updateInformationError   : "",
  }),
  [profileTypes.UPDATE_INFORMATION_SUCCESS]: (state: ProfileStateI) => ({
    ...state,
    updateInformationLoading : false,
    updateInformationError   : "",
  }),
  [profileTypes.UPDATE_INFORMATION_FAILURE]: (state: ProfileStateI, { payload }: getProfileTypes) => ({
    ...state,
    updateInformationLoading : false,
    updateInformationError   : payload,
  }),
  [profileTypes.UPDATE_AVATAR]: (state: ProfileStateI) => ({
    ...state,
    updateAvatarLoading : true,
    updateAvatarError   : "",
  }),
  [profileTypes.UPDATE_AVATAR_SUCCESS]: (state: ProfileStateI) => ({
    ...state,
    updateAvatarLoading : false,
    updateAvatarError   : "",
  }),
  [profileTypes.UPDATE_AVATAR_FAILURE]: (state: ProfileStateI, { payload }: getProfileTypes) => ({
    ...state,
    updateAvatarLoading : false,
    updateAvatarError   : payload,
  }),
};

const reducer = (state: ProfileStateI = initialState, action: getProfileTypes) => {
  const actionReducer = ACTION_REDUCER[action.type];

  return actionReducer ? actionReducer(state, action) : state;
};

export default reducer;
